import { render } from "./NewNews2.vue?vue&type=template&id=14463d75&scoped=true"
import script from "./NewNews2.vue?vue&type=script&lang=js"
export * from "./NewNews2.vue?vue&type=script&lang=js"

import "./NewNews2.vue?vue&type=style&index=0&id=14463d75&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14463d75"]])

export default __exports__